import { Services } from '@/infra/services';
import { type ItemId } from '@/infra/services/catalog/model';

interface GetPaymentMethodsProps {
  itemId: ItemId;
}

export async function getPaymentMethods(
  props: Readonly<GetPaymentMethodsProps>
) {
  const { itemId } = props;

  return await Services.Catalog.Payment.getPaymentMethods({ itemId });
}
